import React from 'react';
import { differenceInSeconds } from 'date-fns';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { translator } from 'mage-i18n';

import { Typography, IllustrationOtherQuestions, Loader, SpacerVertical } from '@klarna/bubble-ui';
import { MOET_CONSTANTS } from 'moet-core';
import { isRunningContextCypress } from 'moet-test-utils/cypress/utils';

import { CAPS } from '@/constants';
import {
  getPayoutsRequestedAt,
  getTransactionsRequestedAt,
  getUserMerchantId,
  isNewSplitLayout,
} from '@/selectors/merchant';
import { withChainedCapabilitiesBeforeNext } from '@/flow/common';
import { getAfterFlowStepForMerchantApplication } from '@/flow/configs/selectors';

const styles = {
  wrapperStyle: isNewSplitLayout => ({
    width: 340,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: 'auto',
    marginTop: isNewSplitLayout ? 60 : 0,
  }),
};

const tPrefix = 'products-fe.pages.checking_page';

export class ApplicationChecking extends React.Component {
  constructor(props) {
    super(props);
    const timeout =
      (isRunningContextCypress(window)
        ? MOET_CONSTANTS.CELEBRATION_TIME_WINDOW_CYPRESS_SECONDS
        : MOET_CONSTANTS.CELEBRATION_TIME_WINDOW_SECONDS - 3) * 1000;

    setTimeout(this.navigate.bind(this), timeout);
  }

  async navigate() {
    const {
      afterFlowStep,
      mid,
      onNext,
      basePath,
      history,
      payoutsRequestedAt,
      transactionsRequestedAt,
    } = this.props;

    onNext({ payload: { params: { mid } }, scrollBeforeNext: true });
    // If the request take too long to go through, it can be that the user gets
    // stuck in between flows

    const timeSinceLastStatusChange = differenceInSeconds(
      new Date(),
      new Date(transactionsRequestedAt || payoutsRequestedAt),
    );

    if (
      timeSinceLastStatusChange >
      (isRunningContextCypress(window)
        ? MOET_CONSTANTS.CELEBRATION_TIME_WINDOW_CYPRESS_SECONDS
        : MOET_CONSTANTS.CELEBRATION_TIME_WINDOW_SECONDS)
    ) {
      history.push(`${basePath}/${afterFlowStep}` + history.location.search);
    }
  }

  render() {
    const { t, isNewSplitLayout } = this.props;

    return (
      <div style={styles.wrapperStyle(isNewSplitLayout)}>
        <IllustrationOtherQuestions />
        <SpacerVertical medium />
        <Typography textToken="text-style/headings/titles/bold/tertiary" align="center">
          {t(`${tPrefix}.title`)}
        </Typography>
        <SpacerVertical extraSmall />
        <Typography textToken="text-style/text/super-paragraphs/body/regular" align="center">
          {t(`${tPrefix}.subtitle`)}
        </Typography>
        <SpacerVertical extraLarge />
        <Loader />
      </div>
    );
  }
}

ApplicationChecking.propTypes = {
  afterFlowStep: PropTypes.string.isRequired,
  basePath: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired,
  isNewSplitLayout: PropTypes.bool.isRequired,
  mid: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  payoutsRequestedAt: PropTypes.string,
  transactionsRequestedAt: PropTypes.string,
};

export default compose(
  connect(state => ({
    afterFlowStep: getAfterFlowStepForMerchantApplication(state),
    mid: getUserMerchantId(state),
    payoutsRequestedAt: getPayoutsRequestedAt(state),
    transactionsRequestedAt: getTransactionsRequestedAt(state),
    t: translator(state),
    isNewSplitLayout: isNewSplitLayout(state),
  })),
  withChainedCapabilitiesBeforeNext({
    getMerchant: CAPS.V2_MERCHANTS_GET,
    getProducts: CAPS.V2_PRODUCTS_GET,
  }),
)(ApplicationChecking);
